import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { DfmPage } from '@/areas/pcb/Pcb/DfmPage/DfmPage';
import { PcbTabRoute } from '@/areas/pcb/Pcb/PcbLayout/PcbTabRoute';
import { assembliesModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/assemblies/$assemblyId/pcb/dfm')({
    staticData: {
        access: { permissions: ['view:assembly'], modulePermissions: assembliesModulePermissions },
        chrome: 'home',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ rfqId: 'required' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PcbTabRoute tab={DfmPage} />;
}
